import 'reflect-metadata';

const Entity = (name: string) => (target: any) => {
    Object.defineProperty(target, 'name', { value: name });
};

export { Entity };
